<script>
  import { mapActions, mapGetters } from "vuex";
  import { moneyFormat } from "@/utility/functions";

  export default {
    name: "ProductDetails",

    props: {
      default: {
        default: () => {},
        type: Object,
      },
      productId: {
        required: true,
        type: Number,
      },
      variants: {
        default: () => [],
        type: Array,
      },
    },

    async created() {
      this.setPageItemClass(this.default.item_class);

      if (this.variants.length > 0) {
        this.setVariants(this.variants);
      }

      this.$nextTick(() => {
        if (Object.keys(this.default).length > 0 && !!this.variantWithSku(this.default.sku)) {
          this.setActiveVariant({ sku: this.default.sku, ignoreUrl: true });
        } else {
          const fallback = this.allVariants.find(
            (variant) => variant.item_class === this.default.item_class
          );

          if (fallback) {
            this.setActiveVariant({ sku: fallback.sku, ignoreUrl: true });
          }
        }
      });
    },

    methods: {
      ...mapActions("product", [
        "setActiveVariant",
        "setImageScene",
        "setPageItemClass",
        "setVariants",
      ]),
    },

    computed: {
      ...mapGetters("product", [
        "activeImageScene",
        "activeVariant",
        "activeVariantThumbs",
        "allVariants",
        "activeVariants",
        "discontinuedVariants",
        "specificationsPath",
        "variantWithSku",
      ]),
    },

    render() {
      return this.$scopedSlots.default({
        activeImageScene: this.activeImageScene,
        moneyFormat: moneyFormat,
        productImageSlides: this.activeVariantThumbs,
        selected: this.activeVariant,
        specificationsPath: this.specificationsPath,
        updateImageScene: this.setImageScene,
        updateSelected: this.setActiveVariant,
        activeVariants: this.activeVariants,
        discontinuedVariants: this.discontinuedVariants,
        priceAvailabilityTarget: this.activeVariant.discontinued
          ? "discontinued-price-availability"
          : "price-availability",
      });
    },
  };
</script>
